import { PetType } from 'constants/pet-type';
import { isEmptyProfile } from 'stores/pet-profile-new/utils/is-empty-profile';
import { PetProfile } from 'types/pet-profile';

/**
 * Resolves the i18n message id for the pet-profile nav label from profile state.
 * Returns null when the pet's own name should be shown instead of a message.
 */
export const getPetProfileLabelMessageId = (
  petProfile: PetProfile,
  species: PetType
): string | null => {
  if (petProfile?.name) {
    return null;
  }

  const isCat = species === PetType.Cat;

  if (isEmptyProfile(petProfile)) {
    return isCat ? 'header:pet-profile-cat' : 'header:pet-profile';
  }

  return isCat ? 'header:pet-profile-cat:mine' : 'header:pet-profile:mine';
};
